/**
 * «15,50» → 1550 копеек. Разделитель любой: владелец набирает и запятую, и точку.
 * Пустое поле — цена не названа, сервер ждёт для этого `null`, а не ноль.
 *
 * Одна на всю форму: цены в прайсе и минимальная цена за штуку считаются одинаково, а две копии
 * такого перевода расходятся молча — округление поправят в одной, а вторая останется с ошибкой.
 */
export const rublesToKopecks = (value: string): number | null => {
  const normalized = value.trim().replace(',', '.')
  if (normalized === '') {
    return null
  }
  const [rubles, kopecks = ''] = normalized.split('.')

  return Number(rubles) * 100 + Number(kopecks.padEnd(2, '0'))
}
